module.exports = __webpack_public_path__ + "static/media/silvana.1033493e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials/silvana.png
// module id = 1421
// module chunks = 0